/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable global-require */
import React, {
    useEffect, useCallback, useState, useMemo,
} from 'react';
import { Portal } from 'react-portal';
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import { tp } from 'app/utils/typograf';
// @ts-ignore
import ScrollLock from 'react-scrolllock';

import { useReferalLink } from 'app/hooks';
import CopyToClipboard from 'react-copy-to-clipboard';
import { isReferralPopupOpenVar } from 'app/apollo/reaction';
import { useReactiveVar } from '@apollo/client';
import { analyticService } from 'global/services';
// import { eventNames } from 'process';
import { CloseButtonCross } from 'app/views/Profile/__NextProfile/CommonCompoents/InviteFriendsBanner/closeButton';
import { isDesktop } from 'app/utils/resolution';
import css from './inviteFriendPopup.module.scss';
import { UIButtonV2 } from '../ui';
import { Desktop, Mobile } from '../Responsive';
import { usePopupOpeningState } from './hooks/usePopupOpeningState';

const after_five = {
    closeEvent: 'After_five_orders_close_referral_pop_up',
    howEvent: 'After_five_orders_how_does_it_work_referral_pop_up',
    shareEvent: 'After_five_orders_share_a_link_referral_pop_up',
    closeHowEvent: 'After_five_orders_close_how_does_it_work_referral_pop_up',
    closeOkEvent: 'After_five_orders_ok_how_does_it_work_referral_pop_up',
};

const survey = {
    closeEvent: 'Survey_close_referral_pop_up',
    howEvent: 'Survey_how_does_it_work_referral_pop_up',
    shareEvent: 'Survey_share_a_link_referral_pop_up',
    closeHowEvent: 'Survey_close_how_does_it_work_referral_pop_up',
    closeOkEvent: 'Survey_ok_how_does_it_work_referral_pop_up',
};

const banner = {
    closeEvent: 'After_five_orders_close_referral_pop_up_from_banner',
    howEvent: 'After_five_orders_how_does_it_work_referral_pop_up_from_banner',
    shareEvent: 'After_five_orders_share_a_link_referral_pop_up_from_banner',
    closeHowEvent: 'After_five_orders_close_how_does_it_work_referral_pop_up_from_banner',
    closeOkEvent: 'After_five_orders_ok_how_does_it_work_referral_pop_up_from_banner',
};

const record = {
    after_five,
    survey,
    banner,
};

const HowItWorkPopup = (props: any) => {
    const { isHowItWorkPopupOpen, toggleHowItWorkPopup, ctx } = props;
    return (
        <Transition
            in={isHowItWorkPopupOpen}
            timeout={isDesktop() ? 0 : 500}
        >
            {(transitionState) => {
                const containerClasses = cn({
                    [css.referralPopupTransition]: true,
                    [css[transitionState]]: true,
                });

                const backdropClasses = cn({
                    [css.referralPopupBackdrop]: true,
                    [css[transitionState]]: true,
                });

                const desktopCrossClasses = cn({
                    [css.inviteFriendPopupHeaderIcon]: true,
                    [css.desktop]: true,
                    [css.gray]: true,
                    [css.withoutWrapper]: true,
                });

                return (
                    <>
                        <div
                            className={backdropClasses}
                            style={{ zIndex: 1007 }}
                            onClickCapture={() => {
                                toggleHowItWorkPopup();
                            }}
                            role="none"
                        />
                        <div className={containerClasses} style={{ zIndex: 1008 }}>
                            <div className={css.howItWorkPopupRoot}>
                                <div className={css.howItWorkPopupTitle}>
                                    Как работает
                                    <br />
                                    реферальная программа?
                                </div>
                                <Mobile>
                                    <div
                                        className={css.inviteFriendPopupHeaderIcon}
                                    >
                                        <CloseButtonCross
                                            modifier="gray"
                                            onClick={() => {
                                                // @ts-expect-error
                                                analyticService.push({ eventName: record[ctx].closeHowEvent });
                                                toggleHowItWorkPopup();
                                            }}
                                        />
                                    </div>
                                </Mobile>
                                <Desktop>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            // @ts-expect-error
                                            analyticService.push({ eventName: record[ctx].closeHowEvent });
                                            toggleHowItWorkPopup();
                                        }}
                                        className={desktopCrossClasses}
                                    >
                                        <img
                                            src={require('./img/closeIcon.dark.d.png')}
                                            alt=""
                                            className={css.inviteFriendPopupHeaderIconItem}
                                            style={{ zIndex: 1009 }}
                                        />
                                    </button>
                                </Desktop>
                                <div className={css.howItWorkPopupContent}>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>1.</span>
                                        {tp.execute('Отправьте свою реферальную ссылку другу, который ранее не пользовался нашим сервисом.')}
                                    </div>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>2.</span>
                                        {tp.execute('Друг должен оформить свой первый заказ по вашей ссылке.')}
                                    </div>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>3.</span>
                                        Как только друг получит свой заказ, мы&nbsp;начислим вам 1&nbsp;000 бонусов на&nbsp;счёт.
                                    </div>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>4.</span>
                                        {tp.execute('Адрес проживания друга должен отличаться от вашего.')}
                                    </div>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>5.</span>
                                        {tp.execute('Бонусы можно копить и оплачивать ими до 100% стоимости заказов.')}
                                    </div>
                                    <div className={css.howItWorkPopupText}>
                                        <span className={css.count}>6.</span>
                                        {tp.execute('Больше друзей — больше бонусов.')}
                                    </div>
                                </div>
                                <div className={css.howItWorkPopupButtonWrapper}>
                                    <Desktop>
                                        <UIButtonV2
                                            // @ts-expect-error
                                            colorType="secondary"
                                            onClick={() => {
                                                // @ts-expect-error
                                                analyticService.push({ eventName: record[ctx].closeOkEvent });
                                                toggleHowItWorkPopup();
                                            }}
                                        >
                                            OK
                                        </UIButtonV2>
                                    </Desktop>
                                </div>
                            </div>
                        </div>
                    </>
                );
            }}
        </Transition>
    );
};

// Пример использования:
export const InviteFriendPopup = (props: any) => {
    const {
        toggleInviteFriendPopup,
        toggleHowItWorkPopup,
        user_ID,
        isInviteFriedPopupOpen,
        ctx,
    } = props;
    const { link } = useReferalLink({ user_ID });
    const [isButtonTapped, setIsButtonTapped] = useState(false);

    /* SELECTORS */
    // const popupTitle = useMemo(() => {
    //     if (ctx === 'survey') {
    //         return <>Рады, что вам понравилось! Хотите скидку?<>;
    //     }

    //     return '1 000 ₽ другу → 1 000 ₽ вам';
    // }, [ctx]);

    /* HANDLERS */
    const onHandleShare = useCallback(async () => {
        if (navigator?.share) {
            await navigator.share({
                // title: 'Скидка 1000₽ от Elementaree',
                // text: 'Пробный сет со скидкой от друга! В нём всё для приготовления 5 ужинов на двоих за 15 минут.',
                url: link,
            });
        }
        // const eventName = (source === 'survey') ? '' : '',
    }, [link]);

    useEffect(
        () => {
            if (!isInviteFriedPopupOpen) {
                setIsButtonTapped(false);
            }
        },
        [isInviteFriedPopupOpen],
    );

    return (
        <div
            className={css.inviteFriendPopupRoot}
        >
            <div className={css.inviteFriendPopupHeader}>
                <img
                    src={require('./img/headerBG.m.png')}
                    alt=""
                    className={css.inviteFriendPopupHeaderBG}
                />
                <div
                    className={css.inviteFriendPopupHeaderIcon}
                >
                    <CloseButtonCross
                        modifier="default"
                        onClick={() => {
                            // @ts-expect-error
                            analyticService.push({ eventName: record[ctx].closeEvent });
                            toggleInviteFriendPopup();
                        }}
                    />
                </div>
            </div>
            <div className={css.inviteFriendPopupContent}>
                <div className={css.inviteFriendPopupContentTitle}>
                    {ctx === 'survey' ? (
                        <>
                            <Mobile>
                                Рады, что вам понравилось!
                                <br />
                                Хотите скидку?
                            </Mobile>
                            <Desktop>
                                Рады, что вам понравилось! Хотите скидку?
                            </Desktop>
                        </>
                    ) : <>1&nbsp;000&nbsp;₽ другу &rarr; 1&nbsp;000&nbsp;₽ вам</>}
                    {/* {tp.execute(popupTitle)} */}
                </div>
                <div className={css.inviteFriendPopupContentText}>
                    <Mobile>
                        <span className={css.count}>1.</span>
                        <span className={css.only320}>
                            Отправьте другу ссылку на&nbsp;набор со&nbsp;скидкой 1&nbsp;000&nbsp;₽
                        </span>
                        <span className={css.only375}>
                            Отправьте другу ссылку на&nbsp;пробный набор со&nbsp;скидкой 1&nbsp;000&nbsp;₽
                        </span>
                    </Mobile>
                    <Desktop>
                        <span className={css.count}>1.</span>
                        Отправьте другу ссылку на&nbsp;пробный набор со&nbsp;скидкой 1&nbsp;000&nbsp;₽
                    </Desktop>
                </div>
                <div className={css.inviteFriendPopupContentText}>
                    <Mobile>
                        <span className={css.count}>2.</span>
                        Когда друг получит свой заказ, вы&nbsp;получите 1&nbsp;000&nbsp;₽ бонусами
                    </Mobile>
                    <Desktop>
                        <span className={css.count}>2.</span>
                        Когда друг получит свой заказ, вы&nbsp;получите 1&nbsp;000&nbsp;₽ бонусами
                    </Desktop>
                </div>
            </div>
            <div className={css.inviteFriendPopupButtons}>
                <UIButtonV2
                    onClick={() => {
                        // @ts-expect-error
                        analyticService.push({ eventName: record[ctx].howEvent });
                        toggleHowItWorkPopup();
                    }}
                    // @ts-expect-error
                    colorType="secondary"
                >
                    Как это работает?
                </UIButtonV2>

                <Mobile>
                    <UIButtonV2
                        onClick={() => {
                            // @ts-expect-error
                            analyticService.push({ eventName: record[ctx].shareEvent });
                            onHandleShare();
                        }}
                    >
                        Поделиться ссылкой
                    </UIButtonV2>
                </Mobile>
                <Desktop>
                    <CopyToClipboard
                        text={link}
                        onCopy={() => {
                            setIsButtonTapped(true);
                        }}
                    >
                        <UIButtonV2
                            onClick={() => {
                                // @ts-expect-error
                                analyticService.push({ eventName: record[ctx].shareEvent });
                            }}
                            tap={isButtonTapped}
                            disabled={isButtonTapped}
                        >
                            {isButtonTapped ? 'Ссылка скопирована' : 'Скопировать ссылку'}
                        </UIButtonV2>
                    </CopyToClipboard>
                </Desktop>
            </div>
        </div>
    );
};

const container = document.querySelector('#root') || document.body;

export function InviteFriendPopupOpener() {
    const [isInviteFriedPopupOpen, setInviteFriedPopupOpen, user_ID] = usePopupOpeningState();
    const [isHowItWorkPopupOpen, setHowItWorkPopupOpen] = useState(false);
    const { ctx } = useReactiveVar(isReferralPopupOpenVar);

    const [layer, setLayer] = useState('initial');

    const toggleInviteFriendPopup = useCallback(() => {
        // @ts-expect-error
        setInviteFriedPopupOpen((isOpen) => !isOpen);
    }, [setInviteFriedPopupOpen]);

    const toggleHowItWorkPopup = useCallback(() => {
        setHowItWorkPopupOpen((isOpen) => {
            const nextLayer = isOpen ? 'first' : 'second';
            setLayer(nextLayer);
            return !isOpen;
        });
    }, []);

    useEffect(() => {
        container.classList.add(css.referralBodyAnimation);
        return () => {
            container.classList.remove(css.referralBodyAnimation);
            container.classList.remove(css.referralBodyAnimationOpen);
        };
    }, []);

    useEffect(() => {
        if (isInviteFriedPopupOpen) {
            container.classList.add(css.referralBodyAnimationOpen);
        } else {
            container.classList.remove(css.referralBodyAnimationOpen);
        }
    }, [isInviteFriedPopupOpen]);

    return (
        <>
            {/* {children({ togglePopup })} */}
            <Portal>
                <Transition
                    // @ts-ignore
                    in={isInviteFriedPopupOpen}
                    timeout={isDesktop() ? 0 : 500}
                >
                    {(transitionState) => {
                        const containerClasses = cn({
                            [css.referralPopupTransition]: true,
                            [css[transitionState]]: true,
                        });

                        const backdropClasses = cn({
                            [css.referralPopupBackdrop]: true,
                            [css[transitionState]]: true,
                            [css[layer]]: true,
                        });

                        return (
                            <>
                                {transitionState === 'entered' && <ScrollLock />}
                                <div
                                    className={backdropClasses}
                                    onClickCapture={toggleInviteFriendPopup}
                                    role="none"
                                    style={{ zIndex: 1004 }}
                                />
                                <div
                                    className={containerClasses}
                                    style={{ zIndex: 1005 }}
                                >
                                    <InviteFriendPopup
                                        isInviteFriedPopupOpen={isInviteFriedPopupOpen}
                                        toggleInviteFriendPopup={toggleInviteFriendPopup}
                                        toggleHowItWorkPopup={toggleHowItWorkPopup}
                                        user_ID={user_ID}
                                        ctx={ctx}
                                    />
                                </div>
                                <HowItWorkPopup
                                    isHowItWorkPopupOpen={isHowItWorkPopupOpen}
                                    toggleHowItWorkPopup={toggleHowItWorkPopup}
                                    ctx={ctx}
                                />
                            </>
                        );
                    }}
                </Transition>
            </Portal>
        </>
    );
}
